import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {TerceroUpPasarelaContratoService} from '../../../../../_services/tercero-up-pasarela-contrato.service';
import {TerceroUPPasarelaContrato} from '../../../../../_models/tercero-up-pasarela-contrato';
import {PlantillaService} from '../../../../../_services/plantilla.service';
import {PlantillaVersionService} from '../../../../../_services/plantilla-version.service';
import {filtrarPorTexto} from '../../admsb-titular.helpers';

@Component({
  selector: 'app-admsb-contratos-tabla',
  templateUrl: './admsb-contratos-tabla.component.html',
  styleUrls: ['./admsb-contratos-tabla.component.scss'],
})
export class AdmsbContratosTablaComponent implements OnInit {

  /** Identificador de la pasarela del titular (idTerceroUPPasarela) */
  @Input() idTitular: string;

  contratos: TerceroUPPasarelaContrato[] = [];
  cargandoContratos = true;

  /** Texto del buscador de la tabla de contratos */
  filtroContratos = '';

  /** Controla la visibilidad del modal de previsualización de contrato */
  mostrarModalContrato = false;

  /** Cuerpo HTML sanitizado de la plantilla asociada al contrato previsualizado */
  contenidoContrato: SafeHtml | null = null;

  constructor(
    private terceroUpPasarelaContratoServicio: TerceroUpPasarelaContratoService,
    private plantillaServicio: PlantillaService,
    private plantillaVersionServicio: PlantillaVersionService,
    private sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
    if (this.idTitular) {
      this.cargarContratos(this.idTitular);
    } else {
      this.cargandoContratos = false;
    }
  }

  private cargarContratos(idTerceroUPPasarela: string): void {
    this.terceroUpPasarelaContratoServicio.listPasarelasContratos(idTerceroUPPasarela).subscribe({
      next: res => {
        this.contratos = res;
        this.cargandoContratos = false;
      },
      error: () => this.cargandoContratos = false,
    });
  }

  /**
   * Contratos filtrados localmente por nombre de plantilla o fecha de la firma según el texto del buscador.
   */
  get contratosFiltrados(): TerceroUPPasarelaContrato[] {
    return filtrarPorTexto(this.contratos, this.filtroContratos, [c => c.nombrePlantilla, c => c.fechaFirma]);
  }

  /**
   * Consulta el cuerpo de la plantilla asociada al contrato (por versión si existe, si no por la plantilla base)
   * y lo muestra en el modal de previsualización.
   */
  previsualizarContrato(contrato: TerceroUPPasarelaContrato): void {
    this.contenidoContrato = null;
    this.mostrarModalContrato = true;
    if (contrato.idPlantillaVersion) {
      this.plantillaVersionServicio.obtenerPorId(contrato.idPlantillaVersion).subscribe(res =>
        this.contenidoContrato = this.sanitizer.bypassSecurityTrustHtml(res.cuerpo));
    } else if (contrato.idPlantilla) {
      this.plantillaServicio.getById(contrato.idPlantilla).subscribe(res =>
        this.contenidoContrato = this.sanitizer.bypassSecurityTrustHtml(res.cuerpo));
    }
  }

  cerrarModalContrato(): void {
    this.mostrarModalContrato = false;
  }

}
